<!--
 * @Author: ljiangyun 396242451@qq.com
 * @Date: 2024-01-02 16:03:35
 * @LastEditors: ljiangyun 396242451@qq.com
 * @LastEditTime: 2024-04-10 10:17:56
 * @FilePath: /光明风控平台_PC端/src/views/kriDetail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Row
    class="kriDetail"
    style="padding-left: 4vw; padding-right: 4vw; padding-top: 2vw"
  >
  <el-button 
  v-if="tableData.length > 0"
  @click="openExcel()" type="warning" icon="el-icon-download" circle style="position:absolute;right:3vw;z-index:999;bottom:0;"></el-button>

    <el-table
      :data="tableData"
      height="80vh"
      style="width: 100%"
      v-if="tableData.length > 0"
    >
      <el-table-column
        :width="type == 1 ? 80 : 150"
        :show-overflow-tooltip="true"
        :prop="'风险分类'"
        :label="getName(type, '风险分类')"
      >
      </el-table-column>
      <el-table-column
        :width="type == 1 ? 120 : 150"
        :show-overflow-tooltip="true"
        :prop="'风险名称'"
        :label="getName(type, '风险名称')"
      >
        <template slot-scope="scope">
          <el-link @click="jump('风险名称', scope.row)" type="warning">{{
            scope.row["风险名称"]
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :prop="'KRI指标名称'"
        :label="getName(type, 'KRI指标名称')"
      >
        <template slot-scope="scope">
          <el-link @click="jump('KRI指标名称', scope.row)" type="warning">{{
            scope.row["KRI指标名称"]
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :prop="'预警公司'"
        :label="getName(type, '预警公司')"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :prop="'风险主责部门'"
        :label="getName(type, '风险主责部门')"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :prop="'上次风险触发时间'"
        :label="getName(type, '上次风险触发时间')"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :prop="'应对预计完成时间'"
        :label="getName(type, '应对预计完成时间')"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :prop="'风险状态'"
        :label="getName(type, '风险状态')"
      >
        <template slot-scope="scope">
          <!-- <div class="greenDot" v-if="item2['状态'] == 0"></div> -->
          <!-- <div
                  class="yellowDot"
                  v-else-if="item2['状态'] > 0 && item2['状态'] < 99"
                ></div>
                <div class="redDot" v-else></div> -->

          <div
            v-if="Number(scope.row['风险状态']) == 0"
            style="display: flex; align-items: center"
          >
            <div class="greenDot"></div>

            {{ getName(type, "风险未预警") }}
          </div>
          <div
            style="display: flex; align-items: center"
            v-if="
              Number(scope.row['风险状态']) > 0 &&
              Number(scope.row['风险状态']) < 99
            "
          >
            <div class="yellowDot"></div>

            {{ getName(type, "预警已处理") }}
          </div>
          <div
            v-if="Number(scope.row['风险状态']) >= 99"
            style="display: flex; align-items: center"
          >
            <div class="redDot"></div>
            {{ getName(type, "预警未处理") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="false"
        :show-overflow-tooltip="true"
        :prop="'风险持续天数'"
        :label="getName(type, '风险持续天数')"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center">
            <el-progress
              stroke-linecap="square"
              :style="
                'width:' + (Number(scope.row['风险持续天数']) / max) * 100 + '%'
              "
              :show-text="false"
              :text-inside="true"
              :stroke-width="18"
              :percentage="100"
              status="warning"
            >
            </el-progress>
            <div style="padding-left: 0.2vw">
              {{ scope.row["风险持续天数"] }}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Row>
</template>

<script>
import { queryBwList,exportRiskInfo } from "../api/index";
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

export default {
  name: "page3",
  components: {
    // ring,
  },
  created() {
    this.setBackurl('back')
    this.setTitle("集团总部风险概览");
    let userInfo = localStorage.getItem("bbsUserInfo");
    if (userInfo) {
      let title = JSON.parse(userInfo).companyName;
      if (
        title == "Bright Food Asia Pacific Pty Ltd." ||
        title == "Salov S.p.A"
      ) {
        this.setTitle("Risk overview");
        this.type = 2;
      }
    }
    queryBwList().then((res) => {
      if (res.code == 200) {
        this.tableData = res.data;
        let list = this.tableData.map((item) => Number(item["风险持续天数"]));
        this.max = Math.max(...list);
        if (this.tableData.length > 0) {
          this.headList = Object.keys(this.tableData[0]);
        }
      }
    });
  },
  data() {
    return {
      type: 1, //1中文 2英文
      headList: [],
      tableData: [],
      max: 1,
      list: [],
      mapData: {
        风险分类: "Risk Category",
        风险名称: "Risk Name",
        KRI指标名称: "KRI Indicator Name",
        预警公司: "Warning Company",
        风险主责部门: "Risk Responsible Department",
        上次风险触发时间: "Last Risk Trigger Time",
        应对预计完成时间: "Expected Completion Time for Response",
        风险状态: "Risk Status",
        风险持续天数: "Days of Risk Continuation",
        风险未预警: "Risk Not Warned",
        预警已处理: "Warning Handled",
        预警未处理: "Warning Unhandled",
      },
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl"]),
    async openExcel(){
      console.log(this.tableData)
      const res = await exportRiskInfo(this.tableData)
      try {
        if(res.filePath){
        window.open(res.filePath, "_blank");
      }
      } catch (error) {
        
      }
     
    },
    getName(type, key) {
      if (type == 1) {
        return key;
      } else if (type == 2) {
        return this.mapData[key] || key;
      }
    },
    jump(type, item) {
      if (type == "风险名称") {
        this.$router.push({
          path: `/PC/page/${item["预警公司"]}/${item["风险名称"]}`,
        });
      }
      if (type == "KRI指标名称") {
        this.$router.push({
          path: `/PC/page/${item["预警公司"]}/${item["风险名称"]}`,
          query: {
            kri: item["KRI指标名称"],
            page: item.page,
            story_id: item.story_id,
          },
        });
      }
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less">
.kriDetail {
  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #bf9d63;
  }
  .el-table .descending .sort-caret.descending {
    border-top-color: #bf9d63;
  }
  .el-progress-bar__outer {
    border-radius: 0 !important;
  }

  .el-progress-bar__inner {
    border-radius: 0 !important;
  }
}
.kriDetail {
  .greenDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    background: #59cf7a;
    flex-shrink: 0;
  }
  .redDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    background: #e16a6a;
    flex-shrink: 0;
  }
  .yellowDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    background: #e4cc88;
    flex-shrink: 0;
  }
  .el-link.el-link--warning {
    color: #fff;
  }
  .el-link.el-link--warning.is-underline:hover:after,
  .el-link.el-link--warning:after {
    border-color: #fff;
  }
  .el-table--scrollable-y .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(147, 147, 153, 0.5);
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
  }
  .el-table::before {
    background: none !important;
  }
  /*最外层透明*/
  .el-table,
  .el-table__expanded-cell {
    background-color: transparent;
    // background: url(../assets/images/background.png) no-repeat;
  }
  /* 表格内背景颜色 */
  .el-table th,
  .el-table tr,
  .el-table td {
    background: transparent;
    // background-color: #242832;
    // background-color: red;
    // background: url(../assets/images/background.png) no-repeat;
  }
  .el-table th {
    color: #bf9d63;
  }
  .el-table td {
    color: #fff;
  }
  // 去掉eltable的hover效果
  .el-table tbody tr:hover > td {
    background-color: #bf9d63 !important;
  }
  .hover-row {
    background-color: #bf9d63 !important;
  }
  .el-table__body tr.hover-row > td.el-table__cell {
    background-color: #bf9d63 !important;
  }
  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: none;
  }
}
</style>
<style lang="less" scoped>
@import "~@/assets/less/index.less";
</style>
